import { render } from "./PolicyForm.vue?vue&type=template&id=7008e588&scoped=true"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"

import "./PolicyForm.vue?vue&type=style&index=0&id=7008e588&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7008e588"]])

export default __exports__